import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ISharePropertyInput,
  ISharePropertyResult,
} from '@shared/models/share';

import { MUTATION_ERROR_FRAGMENT } from '../errors.fragments';

export const SHARE_PROPERTY: TypedDocumentNode<
  ISharePropertyResult,
  ISharePropertyInput
> = gql`
  ${MUTATION_ERROR_FRAGMENT}
  mutation shareProperty($id: ID!, $input: SharePropertyInput) {
    shareProperty(id: $id, input: $input) {
      result {
        id
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;
